import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { FiPlus, FiEdit, FiTrash } from 'react-icons/fi';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { useAuth } from '../contexts/AuthContext';
import ConditionalButton from '../components/common/ConditionalButton';
import ConditionalActions from '../components/common/ConditionalActions';

const TypeParentePage = () => {
  const { user } = useAuth();
  const [types, setTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingType, setEditingType] = useState(null);
  const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();

  const fetchTypes = async () => {
    const res = await api.get('/types_parentes');
    setTypes(res.data.data || []);
  };

  useEffect(() => {
    fetchTypes();
  }, []);

  const onSubmit = async (data) => {
    if (editingType) {
      await api.put(`/types_parentes/${editingType.id}`, data);
    } else {
      await api.post('/types_parentes', data);
    }
    setShowModal(false);
    setEditingType(null);
    reset();
    fetchTypes();
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Types de parenté</h1>
        <ConditionalButton
          entity="type_parentes"
          permission="create"
          className="flex items-center space-x-2 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700"
          onClick={() => setShowModal(true)}
        >
          <FiPlus />
          <span>Nouveau type</span>
        </ConditionalButton>
      </div>
      <div className="bg-white shadow rounded-lg overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Libellé</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {types.length === 0 ? (
              <tr>
                <td colSpan="2" className="px-6 py-4 text-center text-gray-500">Aucun type</td>
              </tr>
            ) : (
              types.map((type) => (
                <tr key={type.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{type.libelle}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <ConditionalActions
                      entity="type_parentes"
                      onEdit={() => {
                        setEditingType(type);
                        setShowModal(true);
                        setValue('libelle', type.libelle);
                      }}
                      onDelete={async () => {
                        const result = await Swal.fire({
                          title: 'Supprimer ce type ?',
                          text: 'Cette action est irréversible.',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#d33',
                          cancelButtonColor: '#3085d6',
                          confirmButtonText: 'Oui, supprimer',
                          cancelButtonText: 'Annuler',
                        });
                        if (result.isConfirmed) {
                          await api.delete(`/types_parentes/${type.id}`);
                          fetchTypes();
                          Swal.fire('Supprimé !', 'Le type de parenté a été supprimé.', 'success');
                        }
                      }}
                      editIcon={FiEdit}
                      deleteIcon={FiTrash}
                      className="flex space-x-2"
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
            <h2 className="text-xl font-semibold mb-4">{editingType ? 'Modifier' : 'Ajouter un'} type de parenté</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Libellé *</label>
                <input {...register('libelle', { required: true })} className="block w-full rounded-lg border border-gray-300 px-3 py-2" />
                {errors.libelle && <span className="text-red-500 text-xs mt-1">Champ obligatoire</span>}
              </div>
              <div className="flex justify-end space-x-2">
                <button type="button" className="px-4 py-2 bg-gray-200 rounded-lg" onClick={() => { setShowModal(false); setEditingType(null); reset(); }}>Annuler</button>
                <ConditionalButton
                  entity="type_parentes"
                  permission={editingType ? "update" : "create"}
                  type="submit"
                  className="px-4 py-2 bg-primary-600 text-white rounded-lg"
                >
                  Enregistrer
                </ConditionalButton>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default TypeParentePage;
